import { DateFormat } from '@agroone/dates'
import { Languages } from '@agroone/entities'

/**
 * Business rules for user-level domain behaviour.
 */

/**
 * Maps each supported language to its conventional date format.
 * Only languages whose format differs from the European default (dd/MM/yy)
 * need an explicit entry here.
 */
const LANGUAGE_DATE_FORMAT_MAP: Partial<Record<Languages, DateFormat>> = {
  [Languages['en-us']]: DateFormat.MM_DD_YY,
  [Languages['hu-hu']]: DateFormat.YYYY_MM_DD,
}

export const UserRules = {
  /**
   * Returns the conventional date format for the given language code.
   * Falls back to dd/MM/yy when the language is unknown or has no specific mapping.
   */
  getDateFormatForLanguage(language: string): DateFormat {
    return LANGUAGE_DATE_FORMAT_MAP[language as Languages] ?? DateFormat.DD_MM_YY
  },
}
